import { Badge, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PaymentClient, type Product } from "@fitness-app/data-models/entities/Product";

import { useAppSelector } from "~/store/initializeStore";
import { getActivePaymentGatewaysForAccount } from "../hooks/usePaymentGateways";

interface ProductPaymentGatewaysStatusProps {
  enabledPaymentGateways?: Product["enabledPaymentGateways"];
  productId: string;
}

export const ProductPaymentGatewaysStatus = ({
  enabledPaymentGateways = [PaymentClient.STRIPE, PaymentClient.TPAY],
  productId,
}: ProductPaymentGatewaysStatusProps) => {
  const integration = useAppSelector((store) => store.productsSettings.data);
  const { t } = useTranslation(["products"]);
  const navigate = useNavigate();

  if (!integration) {
    return null;
  }

  const activePaymentGateways = getActivePaymentGatewaysForAccount(integration);

  const filteredEnabledPaymentGateways = enabledPaymentGateways?.filter((gateway) =>
    activePaymentGateways.includes(gateway),
  );

  const paymentGatewaysInactiveInProduct = activePaymentGateways.filter(
    (gateway) => !filteredEnabledPaymentGateways?.includes(gateway),
  );

  return (
    <div className="flex flex-col gap-2">
      <div>
        {filteredEnabledPaymentGateways?.map((gateway) => {
          return (
            <div key={gateway} className="flex items-center gap-2">
              <Badge color="green" />
              <span>{t(`productTransactions.paymentGateway.${gateway.toLowerCase()}`)}</span>
            </div>
          );
        })}
        {paymentGatewaysInactiveInProduct.map((gateway) => {
          return (
            <div key={gateway} className="flex items-center gap-2">
              <Badge color="red" />
              <span>{t(`productTransactions.paymentGateway.${gateway.toLowerCase()}`)}</span>
            </div>
          );
        })}
      </div>

      <Button
        type="link"
        onClick={() => navigate(`/products/${productId}/settings?tab=checkout`)}
        className="self-start px-0"
      >
        {t("productDetails.goToPaymentGatewaysSettings")}
      </Button>
    </div>
  );
};
